// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

export const SUPABASE_URL = "https://xdcjjtsakwthfuywzyjv.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhkY2pqdHNha3d0aGZ1eXd6eWp2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA3MTM3ODQsImV4cCI6MjA2NjI4OTc4NH0.2ZHh5FSQC1-oeUVH56ML4anQRlP6IaPqKkaz9TmMCFY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);